
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2416_1138)"}},[_c('path',{attrs:{"d":"M6.42 1.267l1.488 2.975 2.975 1.487-2.975 1.487-1.488 2.975-1.487-2.975L1.958 5.73l2.975-1.487L6.42 1.267zm-3.666.108L2.066 0 1.38 1.375l-1.375.688 1.375.687.687 1.375.688-1.375 1.375-.688-1.375-.687zm-.611 7.486l-.535-1.07-.535 1.07-1.07.535 1.07.535L1.608 11l.535-1.07 1.07-.534-1.07-.535z","fill":"#FF00D6"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2416_1138"}},[_c('rect',{attrs:{"width":"11","height":"11","fill":"#fff","transform":"rotate(-180 5.5 5.5)"}})])])])
          )
        }
      }
    